// extracted by mini-css-extract-plugin
export default {"protocolIcon":"styles_protocolIcon__ceCkY","acquisitionLink":"styles_acquisitionLink__Dwp1O"};